import React from 'react';
import { List, ListItem, RichText, TAGTypography, Grid, Container } from '../../';

var Financing = function Financing(props) {
  var branding = props.branding,
      facilityData = props.facilityData,
      intro = props.intro,
      outro = props.outro;
  return React.createElement(React.Fragment, null, intro && React.createElement(RichText, {
    content: intro,
    branding: branding
  }), React.createElement(Grid, null, React.createElement(Container, null, (facilityData === null || facilityData === void 0 ? void 0 : facilityData.insurance) && React.createElement(List, {
    sx: {
      columnCount: {
        sm: 2,
        md: 3
      }
    }
  }, facilityData.insurance.map(function (insurance, i) {
    return React.createElement(ListItem, {
      key: i,
      sx: {
        paddingLeft: 0
      }
    }, React.createElement(TAGTypography, null, insurance.name, " "));
  })))), outro && React.createElement(RichText, {
    content: outro,
    branding: branding
  }));
};

export default Financing;